module.exports = __webpack_public_path__ + "static/media/pause.cceeca9d.svg";